// extracted by mini-css-extract-plugin
export default {"reset":"TZEVz6","visuallyHidden":"rqdASI"};